/**
 * UranIA PA — `/scegli-accesso` (redirect a `/accedi`).
 *
 * Fusione A.4.2 (Riordino della mappa delle rotte §4): il contenuto che
 * viveva qui (`ScegliAccessoPage`, invariato) ora vive su `/accedi`
 * (`routes/accedi.tsx`) — vedi lì per il perché del nome. Questa rotta
 * resta solo come redirect: i link già circolati non si rompono.
 */

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as PubblicoRoute } from './_pubblico.tsx';

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/scegli-accesso',
  beforeLoad: () => {
    throw redirect({ to: '/accedi', replace: true });
  },
});
